import { MessageContentResponse, GetMessagesCollection, ResendMessagesResponse, ResendSingleMessageResponse } from '@gms/communication-api';
import { createInitialDataState, IDataState } from '../app/app.models';
import { SortDescriptor } from '@progress/kendo-data-query';
import { getPagination, IPagination } from 'shared/models/pagination.model';

export interface IMessagingState {
  messages: IDataState<GetMessagesCollection, any>;
  messageContent: { [id: number]: IDataState<MessageContentResponse, any> };
  // Attachments are keyed by messageHeaderId and attachmentFileName
  attachments: { [key: string]: IDataState<Blob, any> };
  resendMessages: IDataState<ResendMessagesResponse, any>;
  resendSingleMessage: { [id: number]: IDataState<ResendSingleMessageResponse, any> };
  sortDescriptors: SortDescriptor[];
  error: Error | null;
  totalCount: number;
  pagination: IPagination;
}

const emptyCollection: GetMessagesCollection = {
  items: [],
  totalCount: 0,
  pageNumber: 1,
  pageSize: 25,
  totalPages: 0,
  hasNextPage: false,
  hasPreviousPage: false
};

export const initialMessagingState: IMessagingState = {
  messages: createInitialDataState(null),
  messageContent: {},
  attachments: {},
  resendMessages: createInitialDataState(null),
  resendSingleMessage: {},
  totalCount: 0,
  sortDescriptors: [
    { field: 'timestamp', dir: 'desc' }
  ],
  error: null,
  pagination: getPagination()
};
